module.exports = __webpack_public_path__ + "static/media/ic205flrenew.ab6e142f.jpg";